import { json, type LoaderFunctionArgs } from '@remix-run/node';
import { getRecentlyViewedServer } from '~/modules-rocco/recently-viewed/api/get-recently-viewed.server';
import { mapRecentlyViewedToTileViewModel } from '~/modules-rocco/recently-viewed/data-mappers/tile-generic';

export const RECENTLY_VIEWED_ACTION = '/actions/recently-viewed';

/**
 * API endpoint to get the user's most recently viewed items. Use with the
 * `useRecentlyViewed` hook.
 * @see {@link packages/web/app/modules-rocco/recently-viewed/hooks/use-recently-viewed.ts}
 */
export const loader = async ({ context }: LoaderFunctionArgs) => {
    const { appDisplayMode, user, logger } = context;
    try {
        const recentlyViewed = await getRecentlyViewedServer(
            { type: 'All' },
            context
        );
        const recentlyViewedTiles = recentlyViewed.RecentlyViewedAll.map(
            (item) =>
                mapRecentlyViewedToTileViewModel(item, user, appDisplayMode)
        );

        return json({
            recentlyViewedItems: recentlyViewedTiles,
        });
    } catch (error) {
        logger.error('Error in /actions/recently-viewed', { error });
        return json(null, { status: 500 });
    }
};
